export const defaultSectionHeaderIconStyle = {
  fontSize: '22px', // Replace with the actual size you want
  color: '#848484'
};
